var React = require('react');
var { connect } = require('react-redux');
var distributionActions = require('distributionActions');
var distributionManager = require('@managers/distributionManager');

class DistributionsDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loadingDistributionId: null };
  }

  async onDropdownSelection(key) {
    if (!key) {
      return;
    }

    const skeletonDist = this.props.distributions?.distributions?.[key];
    if (!skeletonDist) {
      return;
    }

    // 1. Optimistic: reflect the new distribution in the dropdowns right away.
    //    Set the DISTRIBUTION only, with a null farming unit — a skeleton FU has
    //    no fields, and putting it into selected_entities makes every consumer
    //    that reads selectedFarmingUnit.fields/.sensors (the Farm View maps,
    //    etc.) dereference undefined. Leaving farming_unit null means those
    //    consumers' `selectedFarmingUnit && …` guards simply skip. The
    //    dropdowns still show the FU list + first FU name derived locally from
    //    the skeleton (which carries every FU's id/name). Plain setter, so no
    //    history fires on the skeleton tree.
    this.props.dispatch(
      distributionActions.set_selected_entities(skeletonDist, null, null, null),
    );

    // 2. Already-full tree (previously loaded): finalize immediately, then
    //    kick load_distribution_by_id so TTL can trigger ensure_all SWR
    //    (no-op when fresh; bulk distributions(1,5) when past STALE_MS).
    if (distributionManager.isFullDistributionTree(skeletonDist)) {
      this.props.dispatch(
        distributionActions.selected_entities(skeletonDist, null, null, null),
      );
      this.props.dispatch(distributionActions.load_distribution_by_id(key));
      return;
    }

    // 3. Fetch the full tree in the background.
    this.setState({ loadingDistributionId: key });
    let fullDist;
    try {
      fullDist = await this.props.dispatch(
        distributionActions.load_distribution_by_id(key),
      );
    } finally {
      this.setState({ loadingDistributionId: null });
    }

    if (!distributionManager.isFullDistributionTree(fullDist)) {
      return;
    }

    // 4. Finalize on the full tree: resolve to field level + fire history.
    //    farming_unit=null lets the thunk keep the already-selected FU (by id)
    //    and pick its first field.
    this.props.dispatch(
      distributionActions.selected_entities(fullDist, null, null, null),
    );
  }

  render() {
    let sortedDistributions = this.props.distributions_index || [];

    return (
      <div>
        <div className='dropdown text-grey71 font-weight-normal'>
          <div
            className='dropdown-toggle d-flex align-items-center'
            style={{ cursor: 'pointer' }}
            id='dropdownMenuButton'
            data-toggle='dropdown'
            aria-haspopup='true'
            aria-expanded='false'
          >
            <div className='overflow-hidden text-truncate'>
              <span className='text-style-titles-16-regular text-grey45'>
                {this.props.active_distribution &&
                  this.props.active_distribution.name}
              </span>
            </div>
          </div>
          <div
            className='dropdown-menu scrollable-menu'
            aria-labelledby='dropdownMenuButton'
          >
            {sortedDistributions.map((current_distribution) => {
              const isLoading =
                this.state.loadingDistributionId === current_distribution.id;
              return (
                <a
                  className='dropdown-item text-grey71'
                  href='#'
                  key={current_distribution.id}
                  onClick={(e) => {
                    e.preventDefault();
                    this.onDropdownSelection(current_distribution.id);
                  }}
                >
                  {current_distribution.name}
                  {isLoading ? ' ...' : ''}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    distributions: state.distribution_data.distributions,
    distributions_index: distributionActions.selectDistributionsIndex(
      state.distribution_data.distributions?.distributions,
    ),
    active_distribution: state.distribution_data.selected_entities.distribution,
    active_farming_unit: state.distribution_data.selected_entities.farming_unit,
  };
};

module.exports = connect(mapStateToProps)(DistributionsDropdown);
